import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { ContractObjectUpdateInput } from 'gql/graphql';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { uerUpdateWorkOrderChangeObjectGql } from '../../WorkOrderChangeQueries';

const requestId = 'uerUpdateWorkOrderChangeObject';

export const useUerUpdateWorkOrderChangeObject = (workOrderChangeId?: number, onSuccess?: () => void) => {
    const dispatch = useDispatch();

    const [uerUpdateWorkOrderChangeObjectReset] = useResetStoreData({ requestId });

    const onSuccessLocal = useCallback(() => {
        uerUpdateWorkOrderChangeObjectReset(undefined);
        onSuccess?.();
    }, [uerUpdateWorkOrderChangeObjectReset, onSuccess]);

    const [, uerUpdateWorkOrderChangeObjectStatus, , uerUpdateWorkOrderChangeObjectRequest] = useRequest({
        requestId,
        query: uerUpdateWorkOrderChangeObjectGql,
        withEffect: false,
        dependenciesUpdater: onSuccessLocal,
    });

    const uerUpdateWorkOrderChangeObjectMakeRequest = useCallback(
        (input: ContractObjectUpdateInput) => {
            dispatch(uerUpdateWorkOrderChangeObjectRequest({ workOrderChangeId, input }));
        },
        [dispatch, uerUpdateWorkOrderChangeObjectRequest, workOrderChangeId],
    );

    useEffect(() => {
        uerUpdateWorkOrderChangeObjectReset(undefined);
    }, [uerUpdateWorkOrderChangeObjectReset]);

    return {
        uerUpdateWorkOrderChangeObjectStatus,
        uerUpdateWorkOrderChangeObjectMakeRequest,
    };
};
